export default __webpack_public_path__ + "static/media/robo.0abfec20.png";